import request from '../../axios';

const PostToolRequirement = async (payload: IToolRequirementPayload) => {
  const newPayload = {
    title: payload.title,
    ad_type: payload.ad_type,
    sub_input: payload.sub_input?.guid,
    location: `POINT (${payload.location?.lng} ${payload.location?.lat})`,
    wanted_number: payload?.wanted_number,
    number_unit: payload.weight_unit?.value,
    brs_type: payload.srs_type?.type,
    only_massage_buyer: payload.only_massage_buyer || false,
    is_change_title: payload?.is_change_title,
  };
  const res = await request.post(`api/v2/wanted/tool-requirement`, {
    ...newPayload,
  });

  return res.data;
};

export default PostToolRequirement;
